import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/rashidpbi/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/rashidpbi" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://x.com/rashidpbi" target="_blank" rel="noreferrer" ><FaSquareXTwitter /></a>
      <a href="https://www.instagram.com/rashid_pbi/" target="_blank" rel="noreferrer" ><FaInstagram /></a>
      
    </div>
  )
}

export default HeaderSocials